/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {TableHeaderEntryModel} from '../../../shared/table/models/table-header-entry.model';
import {BundleSettlementsColumnEnum} from '../models/bundle-settlements-column.enum';
import * as BundleSettlementsDataPipes from '../data-pipes/bundle-settlements-table-data-pipes';
import * as FinancialNumberDataPipe from '../../util/financial-number/pipe/financial-number-data-pipe';
import {UndefinedValuePipe} from '../../../shared/pipes/undefined-value/undefined-value.pipe';

const bundleSettlementsTableHeadersConfiguration: {
    suppliers: TableHeaderEntryModel<BundleSettlementsColumnEnum>;
    complaint: TableHeaderEntryModel<BundleSettlementsColumnEnum>;
    settlement: TableHeaderEntryModel<BundleSettlementsColumnEnum>;
    partsTotalNetAmount: TableHeaderEntryModel<BundleSettlementsColumnEnum>;
    teMinutesTotalAmount: TableHeaderEntryModel<BundleSettlementsColumnEnum>;
    partsTotalGrossAmount: TableHeaderEntryModel<BundleSettlementsColumnEnum>;
} = {
    suppliers: {
        code: BundleSettlementsColumnEnum.SUPPLIER,
        name: 'Supplier',
        sortable: false,
        widthWeight: 7,
        dataPipe: BundleSettlementsDataPipes.suppliersPipe,
        hasCopyPaste:true
    },
    complaint: {
        code: BundleSettlementsColumnEnum.COMPLAINT_CODE,
        name: 'Complaint No.',
        sortable: false,
        widthWeight: 5,
        hasCopyPaste: true
    },
    settlement: {
        code: BundleSettlementsColumnEnum.SETTLEMENT_CODE,
        name: 'Settlement No.',
        sortable: false,
        widthWeight: 5,
        dataPipe: (new UndefinedValuePipe()).transform,
        hasCopyPaste: true
    },
    partsTotalNetAmount: {
        code: BundleSettlementsColumnEnum.PARTS_TOTAL_NET_COST,
        name: 'Total net amount',
        sortable: false,
        widthWeight: 7,
        dataPipe: FinancialNumberDataPipe.financialNumberPipe,
        hasTextAlignRight: true,
        hasCopyPaste: true
    },
    partsTotalGrossAmount: {
        code: BundleSettlementsColumnEnum.PARTS_TOTAL_GROSS_COST,
        name: 'Total amount',
        sortable: false,
        widthWeight: 7,
        dataPipe: FinancialNumberDataPipe.financialNumberPipe,
        hasTextAlignRight: true,
        hasCopyPaste: true
    },
    teMinutesTotalAmount: {
        code: BundleSettlementsColumnEnum.TE_MINUTES_TOTAL_COST,
        name: 'TE minutes total amount',
        sortable: false,
        widthWeight: 14,
        dataPipe: FinancialNumberDataPipe.financialNumberPipe,
        hasTextAlignRight: true
    }
};

export default bundleSettlementsTableHeadersConfiguration;
